import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useFeatures } from '@/services/backstage/useFeatures';

export const RequireFeature: FC<{ names: string | string[] }> = ({ names }) => {
  const location = useLocation();
  const hasFeature = useFeatures(names);

  if (!hasFeature) {
    return <Navigate to={'*'} replace={true} state={{ restore: location.pathname }} />;
  }

  return <Outlet />;
};
